import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import {
  DeleteContentSuccess,
  LoadContentSuccess,
  PostSaveComplete,
  PostSaveFail,
  UpdateContentSuccess
} from 'src/app/features/content/redux/content.actions';
import { Content } from 'src/app/models/content';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({ providedIn: 'any' })
export class ContentService {
  public allKeys: string[] = [];
  public content_api = APIS.CONTENT;
  public single_content_api = APIS.SINGLE_CONTENT;
  public type = 'content';

  constructor(
    private store: Store,
    private toastrService: NbToastrService,
    private utilityService: UtilityService,
    private apiService: AmplifyApiService
  ) {}

  public loadContentAmplify(reload = false) {
    this.apiService
      .get(this.content_api, `/${ENVIRONMENT.name}/content`, {})
      .then((response) => {
        if (reload) {
          this.toastrService.show(status, $localize`Fetching Content Complete`, {
            status: 'success'
          });
        }
        this.store.dispatch(new LoadContentSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show(status, $localize`Fetching Content Failed`, {
          status: 'danger'
        });
      });
  }

  public postContentAmplify(newContent: Content) {
    this.apiService
      .post(this.content_api, `/${ENVIRONMENT.name}/content`, { body: newContent })
      .then((response) => {
        this.store.dispatch(new PostSaveComplete(response));
      })
      .catch((error) => {
        this.store.dispatch(new PostSaveFail(error));
      });
  }

  public updateContentAmplify(newContent: Content) {
    this.apiService
      .put(this.content_api, `/${ENVIRONMENT.name}/content`, { body: newContent })
      .then((response) => {
        this.toastrService.show(status, $localize`Updating Content Success`, {
          status: 'success'
        });
        this.store.dispatch(new UpdateContentSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        const message = this.utilityService.convertErrorToMessage(error);
        this.toastrService.show(status, $localize`Updating Content Failed: ${message}`, {
          status: 'danger'
        });
      });
  }

  public deleteContentAmplify(content: Content) {
    this.apiService
      .delete(this.single_content_api, `/${ENVIRONMENT.name}/content/${content.content_key}`, { body: content })
      .then(() => {
        this.toastrService.show(status, $localize`Deleting Content Success`, {
          status: 'success'
        });
        this.store.dispatch(new DeleteContentSuccess(content));
      })
      .catch((error) => {
        console.error(error);
        const message = this.utilityService.convertErrorToMessage(error);
        this.toastrService.show(status, $localize`Deleting Content Failed: ${message}`, {
          status: 'danger'
        });
      });
  }
}
